import * as React from 'react';
import * as autoBind from 'react-autobind';
import DatePicker from 'react-datepicker';
import DeadlineControls from '../DeadlineControls/DeadlineControls';
import Themeable from '../../types/Themeable';

export default class DeadlineInput extends React.Component<DeadlineInputProps, {}> {
   ignoreInputClick: boolean;
   inputRef: any;

   constructor(props: DeadlineInputProps) {
      super(props);
      autoBind(this);

      this.inputRef = React.createRef();
   }

   selectDate(date: Date) {
      this.props.changeDate(date);
   }

   onClickOutside(e: any) {
      if (this.inputRef && this.inputRef.current.contains(e.target)) {
         this.ignoreInputClick = true;
      }
   }

   handleClickInput() {
      this.ignoreInputClick = false;
   }

   render() {
      const {themeName, reviewByDate, disabled, removeDate} = this.props;
      const customInput = <DeadlineControls themeName={themeName} reviewByDate={reviewByDate} removeDate={removeDate} innerRef={this.inputRef} onClick={this.handleClickInput}/>;
      const selectedDate = reviewByDate ? reviewByDate : new Date();

      return (
         <DatePicker
            disabled={disabled}
            selected={selectedDate}
            popperPlacement="top-end"
            customInput={customInput}
            className="review-by-date-picker"
            fixedHeight
            onChange={this.selectDate}
            minDate={new Date()}
            todayButton="Today"
            calendarClassName="review-by-date-calendar"
            onClickOutside={this.onClickOutside}
         />
      );
   }
}

export interface DeadlineInputProps extends Themeable {
   reviewByDate: Date;
   disabled?: boolean;
   changeDate(date: Date): void;
   removeDate(): void;
}
